import TimezonePicker, { DEFAULT_TIMEZONE } from './TimezonePicker';

export default TimezonePicker;
export { DEFAULT_TIMEZONE };
